<!-- Search row -->
<div class="row d-flex align-items-center py-1 list-search-container-zone">
  <div class="col-12">
    <div class="list-search-container pe-1">
      <i class="fas fa-search list-search-icon"></i>
      <input type="text"
             [(ngModel)]="filter"
             placeholder="{{ 'Search media files' | translate }}"
             class="form-control list-search-input flex-grow-1">
      <i *ngIf="filter"
         (click)="filter = ''"
         class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
         aria-hidden="true"></i>
    </div>
  </div>
</div>

<!-- List zone -->
<div class="list-search-options-zone">
  <!-- Loading -->
  <div *ngIf="loading" class="d-flex justify-content-center my-5">
    <i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
  </div>

  <!-- Empty -->
  <div *ngIf="!loading && filtered().length === 0" class="d-flex justify-content-center my-5 text-muted">
    <span>{{ (files.length === 0 ? 'No files in the library yet.' : 'No media files match the filter.') | translate }}</span>
  </div>

  <!-- File rows -->
  <div *ngIf="!loading && filtered().length > 0" class="expanded-list row px-3 pb-0">
    <div class="col px-4 list-item-container">
      <div *ngFor="let f of filtered()"
           class="item py-2 row cursor-pointer"
           [class.selected]="f.id === selectedMediaFileId"
           (click)="choose(f)">
        <div class="col d-flex align-items-center">
          <i class="far fa-file mr-2 text-muted"></i>
          <span class="flex-grow-1 text-truncate" [title]="f.name">{{ f.name }}</span>
          <span class="text-muted small ml-3 flex-shrink-0">{{ formatSize(f.sizeBytes) }}</span>
          <span class="text-muted small ml-3 flex-shrink-0">{{ f.uploadedAt | date:"short" }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
